
import { defineStore } from 'pinia';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useRolesStore } from './roles';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isLoggedIn: false,
  }),
  
  actions: {
    initializeAuth() {
      onAuthStateChanged(auth, async (user) => {
        this.user = user;
        this.isLoggedIn = !!user;
        
        // Initialize user role when authentication state changes
        const rolesStore = useRolesStore();
        if (user) {
          console.log('Auth state changed - User email:', user.email);
          
          // Check for admin email FIRST before initializing role
          if (user.email === 'marcswakes@gmail.com') {
            console.log('Admin email detected, setting admin role');
            await rolesStore.setUserRole(user.uid, 'admin');
          } else {
            console.log('Regular user, initializing default role');
            await rolesStore.initializeUserRole(user.uid);
          }
        } else {
          await rolesStore.initializeUserRole(null);
        }
      });
    },
    setUser(user) {
      this.user = user;
      this.isLoggedIn = !!user;
    }
  }
});
